class HomeVideo {
  constructor(el) {
    this.el = el;
    this.poster = this.el.querySelector("figure");
    this.playIcon = this.el.querySelector(".icon");
    this.iframe = this.el.querySelector("iframe");

    if (!this.iframe) {
      return;
    }

    this.bindEvents();
  }

  bindEvents() {
    if (this.poster) {
      this.poster.addEventListener("click", this.play.bind(this), false);
    }

    if (this.playIcon) {
      this.playIcon.addEventListener("click", this.play.bind(this), false);
    }
  }

  play(event) {
    if (event) {
      event.preventDefault();
    }

    if (this.poster) {
      this.poster.classList.add("hide");
    }

    if (this.playIcon) {
      this.playIcon.classList.add("hide");
    }

    const src = this.iframe.getAttribute("src");
    if (!src || this.hasAutoplay(src)) {
      return;
    }

    this.iframe.setAttribute("src", this.addAutoplay(src));
  }

  hasAutoplay(src) {
    try {
      const url = new URL(src, window.location.origin);
      return url.searchParams.get("autoplay") === "1";
    } catch (error) {
      return /(?:\?|&)autoplay=1(?:&|$)/.test(src);
    }
  }

  addAutoplay(src) {
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set("autoplay", "1");
      return url.toString();
    } catch (error) {
      const separator = src.includes("?") ? "&" : "?";
      return `${src}${separator}autoplay=1`;
    }
  }
}

function initHomeVideo() {
  const videos = document.querySelectorAll(".template-home .video-block");

  for (let video of videos) {
    new HomeVideo(video);
  }
}

document.addEventListener("DOMContentLoaded", initHomeVideo);